import Icon from '../../../components/AppIcon';
import { ContactMethod } from '../types';

interface ContactMethodsProps {
  methods: ContactMethod[];
  onMethodSelect: (method: ContactMethod) => void;
}

const ContactMethods = ({ methods, onMethodSelect }: ContactMethodsProps) => {
  return (
    <section className="py-16 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-brand-primary mb-4">
            Choose Your Preferred Contact Method
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            We offer multiple ways to connect based on your communication preference and urgency level
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {methods.map((method) => (
            <button
              key={method.id}
              onClick={() => onMethodSelect(method)}
              disabled={!method.available}
              className={`relative bg-card border-2 rounded-xl p-6 text-left transition-all duration-fast hover:shadow-lg ${
                method.available
                  ? 'border-border hover:border-primary cursor-pointer' :'border-border opacity-50 cursor-not-allowed'
              }`}
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name={method.icon} size={24} className="text-primary" />
                </div>
                {method.available && (
                  <div className="w-2 h-2 bg-success rounded-full"></div>
                )}
              </div>
              
              <h3 className="text-lg font-semibold text-brand-primary mb-2">
                {method.name}
              </h3>
              
              <p className="text-sm text-text-secondary mb-4">
                {method.description}
              </p>
              
              <div className="flex items-center space-x-2 text-primary text-sm font-medium">
                <span>{method.action}</span>
                <Icon name="ArrowRight" size={16} />
              </div>
              
              {!method.available && (
                <div className="absolute top-4 right-4 bg-muted text-muted-foreground text-xs px-2 py-1 rounded">
                  Coming Soon
                </div>
              )}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactMethods;